import React, { useEffect, useState } from 'react';
import { isEqualArrayContent, modifyNotificationCards, translatedNoficationTitle } from '../services/notifications-helper';
import Accordion from '../../../sharedmodules/components/accordion';
import { DndProvider } from 'react-dnd';
import DragAndDrop from '../../../sharedmodules/components/drag-and-drop';
import { HTML5Backend } from 'react-dnd-html5-backend';
import NotificationListItem from './notification-list-item';
import PropTypes from 'prop-types';
import { createSequenceRequestPayload } from '../services/create-sequence-request-payload';

const NotificationAccordionItem = ({
    notificationItem,
    handlerEditNotification, deleteNotification, updateNotificationSequence, closeOpenModal,
}) => {

    const notificationIdList =
        notificationItem.notifications.map((notification) => ({ id: notification.id }));
    const previousNotificationIdList = [...notificationIdList];
    const notificationMapperTable = notificationItem.notifications;
    const [notificationIdState, setNotificationIdState] = useState(notificationIdList);
    const [sequenceRequestState, setSequenceRequestState] = useState({});
    const [isDragState, setIsDragState] = useState(false);
    if (notificationIdList.length !== notificationIdState.length) {

        setNotificationIdState([...notificationIdList]);

    }

    useEffect(() => {

        setNotificationIdState([...notificationItem.notifications.map(
            (notification) => ({ id: notification.id }),
        )]);
        setSequenceRequestState({});

    }, [notificationItem.notifications]);

    const onCardMove = (dragIndex, hoverIndex) => {

        const modifiedNotificationCard =
            modifyNotificationCards(notificationIdState, dragIndex, hoverIndex);
        setNotificationIdState([...modifiedNotificationCard]);
        if (previousNotificationIdList.length === modifiedNotificationCard.length) {

            setIsDragState(!isEqualArrayContent(previousNotificationIdList,
                modifiedNotificationCard));

        }

    };

    const onCardPush = () => {

        if (isDragState) {

            const keyOrder = notificationIdState.map((notification) => notification.id);
            setSequenceRequestState({
                ...createSequenceRequestPayload(keyOrder, notificationItem.language),
            });

        } else {

            setSequenceRequestState({});

        }

    };

    const notificationListItem = (
        <DndProvider backend={HTML5Backend}>
            <DragAndDrop
                availableItems={notificationIdState}
                containerId={notificationItem.language}
                idAttribute="id"
                childComponent={<NotificationListItem />}
                isDisplayValueMapped
                mappingId="title"
                mappingTable={notificationMapperTable}
                onCardMove={onCardMove}
                onCardPush={onCardPush}
                onCardRemove={() => ''}
                selectedItems={notificationIdState}
                editNotificationHander={handlerEditNotification}
                deleteNotification={deleteNotification}
            />
        </DndProvider>
    );

    return (
        <Accordion
            accordion="props.claimsAccordion"
            body={notificationListItem}
            onAccordionToggle="props.onAccordionToggle"
            title={`${translatedNoficationTitle(notificationItem.language)} (${notificationItem.notifications.length})`}
            addAccordianContents
            updateSequenceContents={Object.keys(sequenceRequestState).length !== 0}
            handleupdateSequenceContent={() => {

                updateNotificationSequence(sequenceRequestState); setSequenceRequestState({});

            }}
            handleAddAccordinanContent={closeOpenModal}
        />
    );

};

const NotificationList = ({
    notificationList,
    closeOpenModal, editNotification, deleteNotification, updateNotificationSequence,
}) => (
    <div className="notifications-list">
        {
            notificationList.map((item) => (
                <NotificationAccordionItem
                    key={item.language}
                    notificationItem={item}
                    closeOpenModal={() => closeOpenModal(item)}
                    handlerEditNotification={editNotification}
                    deleteNotification={deleteNotification}
                    updateNotificationSequence={updateNotificationSequence}
                />
            ))
        }
    </div>
);

NotificationList.propTypes = {
    closeOpenModal: PropTypes.func.isRequired,
    notificationList: PropTypes.array.isRequired,
    editNotification: PropTypes.func.isRequired,
    deleteNotification: PropTypes.func.isRequired,
    updateNotificationSequence: PropTypes.func.isRequired,
};

NotificationAccordionItem.propTypes = {
    closeOpenModal: PropTypes.func.isRequired,
    notificationItem: PropTypes.object.isRequired,
    handlerEditNotification: PropTypes.func.isRequired,
    deleteNotification: PropTypes.func.isRequired,
    updateNotificationSequence: PropTypes.func.isRequired,
};

export default NotificationList;
